import React, {Component} from 'react';
import FieldsFactory from '../../ui_core/fieldsFactory';
import Error from '../../ui_core/message/errors';
import Normal from '../../ui_core/message/normal';
import config from '../../config';


class Priority extends Component {
    constructor(props) {
        super(props);
        this.control = {
            onChange:      this.onChange.bind(this),
            onCreate:      this.onCreate.bind(this),
            onDelete:      this.onDelete.bind(this),
            onPositionUpdate:      this.onDelete.bind(this),
        };
        this.getData = this.props.props.tools.getData.bind(this);
        this.state = {
            message: {
                error: '',
                text:  '',
            },
            values:  [],
        };
        this.getGroups = this.getGroups.bind(this);
        this.resetMessage = this.resetMessage.bind(this);
    }

    async errorCheck(response) {
        const getJSON = async (response) => {
            return await response.json().then(jsonData => jsonData);
        };
        let res;
        let message;

        res = response;
        if (response.body) {
            res = await getJSON(response);
        }
        message = {
            error: [
                       'Status: ' + (response.status || response.name),
                       res.error || '',
                       response.statusText || '',
                       res.message || '',
                   ].join('<Br/>'),
        };

        this.setState({
            message,
        });

        throw new Error(message);
    }

    getGroups () {
        this.getData('/priority/get')
            .then((data) => {
                console.log(data);

                this.setState({
                    ...this.state,
                    values: data || [],
                });
            });
    }

    createGroupFetch(groupData, successes) {
        const headers = new Headers({
            'Content-Type': 'application/json',
        });
        const data = {
            method:      'POST',
            headers:     headers,
            body:        JSON.stringify(groupData),
            credentials: 'include',
        };

        return fetch(config.endpoint + '/priority/create' + window.location.search, data)
            .then(res => res.json())
            .then(data => {
                if (data && data.status === 'ok') {
                    typeof successes === 'function' && successes();
                }

                if(data && data.error){
                    this.errorCheck(data);
                }

            })
            .catch(async (response) => {
                this.errorCheck(response);
            });
    }

    deleteGroupFetch(groupID, successes) {
        const headers = new Headers({
            'Content-Type': 'application/json',
        });
        const data = {
            method:      'POST',
            headers:     headers,
            body:        JSON.stringify(groupID),
            credentials: 'include',
        };

        return fetch(config.endpoint + '/priority/delete' + window.location.search, data)
            .then(res => res.json())
            .then(data => {
                if (data && data.status === 'ok') {
                    typeof successes === 'function' && successes();
                }

                if(data && data.error){
                    this.errorCheck(data);
                }

            })
            .catch(async (response) => {
                this.errorCheck(response);
            });
    }

    sendData(priorityData) {
        const headers = new Headers({
            'Content-Type': 'application/json',
        });
        const data = {
            method:      'POST',
            headers:     headers,
            body:        JSON.stringify(priorityData),
            credentials: 'include',
        };

        return fetch(config.endpoint + '/priority/update' + window.location.search, data)
            .then(res => res.json())
            .catch(async (response) => {
                this.errorCheck(response);
            });
    }


    onCreate (data){
        console.log('add', data);
        this.createGroupFetch({instanceId: data.target.groupId, name: data.target.groupName}, this.getGroups);
    }

    onDelete (data) {
        this.deleteGroupFetch({id: data.target.groupId}, this.getGroups)
    }

    onChange(data) {
        if (this.state.values) {
            this.sendData(data.target)
                .then((response) => {
                    if (response.error) {
                        this.errorCheck(response);
                    } else {
                        this.setState({
                            ...this.state,
                            message: {
                                error: '',
                                text:  response.status === 'ok' ? 'Done!' : '',
                            },
                        });
                        this.getGroups();
                    }
                });
        }
    }

    resetMessage() {
        this.setState({
            ...this.state,
            message: {
                error: '',
                text:  '',
            },
        });
    }

    componentDidMount() {
        this.getGroups();
    }

    render() {
        return (
            <div>
                <div className="defaultWrapper">
                    <form>
                        {this.state.message.error ? <Error error={this.state.message.error}/> : ''}
                        {this.state.message.text ?
                            <Normal removeMessage={this.resetMessage} message={this.state.message.text}/> : ''}
                        <div className="wrapper_row">
                            <div className="right-col block">
                                <FieldsFactory title="L’ordre de priorité"
                                               {...this.control}
                                               type="sortList"
                                               name={'groupName'}
                                               name_additional={'groupId'}
                                               placeholder={'Titre'}
                                               placeholder_additional={'ID de contenu cloud'}
                                               value={this.state.values}
                                />
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        );
    }
}

export default Priority;
